import { render } from "./HelloWorld.vue?vue&type=template&id=33d6fbd0&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=33d6fbd0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-devops/vue-devops/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d6fbd0"]])

export default __exports__